export default {
  // Base sizes
  sm: "w-4 h-4",
  md: "w-6 h-6",
  lg: "w-8 h-8",
  xl: "w-12 h-12",

  // Thicknesses are controlled by the stroke opacity and width
  thin: "[&>svg>path.track]:opacity-20 [&>svg>path]:stroke-[6]",
  regular: "[&>svg>path.track]:opacity-25 [&>svg>path]:stroke-[8]",
  thick: "[&>svg>path.track]:opacity-30 [&>svg>path]:stroke-[10]",

  // Speeds
  slow: "[&>svg]:animate-[spin_2s_linear_infinite]",
  normal: "[&>svg]:animate-[spin_1s_linear_infinite]",
  fast: "[&>svg]:animate-[spin_0.5s_linear_infinite]",

  // Color schemes — site theme
  primary: "text-primary stroke-primary",
  secondary: "text-secondary stroke-secondary",
  white: "text-white stroke-white",
  dark: "text-text stroke-text",
  muted: "text-text_secondary stroke-text_secondary",

  // Color schemes — admin theme
  admin_primary: "text-admin_primary stroke-admin_primary",
  admin_secondary: "text-admin_secondary stroke-admin_secondary",
  success: "text-admin_success stroke-admin_success",
  danger: "text-admin_error stroke-admin_error",
  warning: "text-admin_warning stroke-admin_warning",
  info: "text-admin_primary stroke-admin_primary",
  light: "text-admin_neutral_1 stroke-admin_neutral_1",

  // Common combinations — site theme
  "primary-thin":
    "w-6 h-6 text-primary stroke-primary [&>svg]:animate-[spin_1s_linear_infinite] [&>svg>path.track]:opacity-20 [&>svg>path]:stroke-[6]",

  // Common combinations — admin theme
  "admin-primary-thin":
    "w-6 h-6 text-admin_primary stroke-admin_primary [&>svg]:animate-[spin_1s_linear_infinite] [&>svg>path.track]:opacity-20 [&>svg>path]:stroke-[6]",
  "secondary-thick":
    "w-6 h-6 text-admin_secondary stroke-admin_secondary [&>svg]:animate-[spin_1s_linear_infinite] [&>svg>path.track]:opacity-30 [&>svg>path]:stroke-[10]",
  "danger-fast":
    "w-6 h-6 text-admin_error stroke-admin_error [&>svg]:animate-[spin_0.5s_linear_infinite] [&>svg>path.track]:opacity-25 [&>svg>path]:stroke-[8]",

  // Special use cases
  button:
    "w-4 h-4 text-white stroke-white [&>svg]:animate-[spin_1s_linear_infinite] [&>svg>path.track]:opacity-20 [&>svg>path]:stroke-[6]",
  loading:
    "w-8 h-8 text-admin_primary stroke-admin_primary [&>svg]:animate-[spin_1s_linear_infinite] [&>svg>path.track]:opacity-25 [&>svg>path]:stroke-[8]",
  "site-loading":
    "w-8 h-8 text-primary stroke-primary [&>svg]:animate-[spin_1s_linear_infinite] [&>svg>path.track]:opacity-25 [&>svg>path]:stroke-[8]",
  minimal:
    "w-4 h-4 text-text_secondary stroke-text_secondary [&>svg]:animate-[spin_1s_linear_infinite] [&>svg>path.track]:opacity-20 [&>svg>path]:stroke-[6]",

  // With backgrounds
  "card-loading":
    "w-6 h-6 text-admin_primary stroke-admin_primary [&>svg]:animate-[spin_1s_linear_infinite] [&>svg>path.track]:opacity-25 [&>svg>path]:stroke-[8] bg-admin_paper rounded-full p-1",
  overlay:
    "w-12 h-12 text-white stroke-white [&>svg]:animate-[spin_1s_linear_infinite] [&>svg>path.track]:opacity-25 [&>svg>path]:stroke-[8] bg-black/50 rounded-full p-2",
}
